/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Speed_LabelInputs */

const en_homepage_features_speed_label = /** @type {(inputs: Homepage_Features_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed`)
};

const es_homepage_features_speed_label = /** @type {(inputs: Homepage_Features_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad`)
};

/**
* | output |
* | --- |
* | "Speed" |
*
* @param {Homepage_Features_Speed_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_speed_label = /** @type {((inputs?: Homepage_Features_Speed_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Speed_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_speed_label(inputs)
	return en_homepage_features_speed_label(inputs)
});